<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="investorInterestId !== null" :confirm="true"
                    :title="$t('Modify') + ' ' + $t('l') +' ' + $t('versement')" route-back="InvestorInterestIndex"/>
        <back-arrow v-else-if="investorName !== null" :confirm="askConfirm"
                    :params="{investorContratId:investorContratId}"
                    :title="$t('Add.versement') + ' - ' + investorName" route-back="InvestorShow"/>
        <back-arrow v-else :confirm="askConfirm" :params="{investorContratId:this.form.contrat.value}"
                    :title="$t('Add.versement')" route-back="InvestorInterestIndex"/>

      </div>

      <b-card class="col-md-12 my-3">
        <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

          <div class="row">
            <div class="col-md-6">

              <b-form-group
                v-if="investorName === null"
                :invalid-feedback="form.contrat.invalidFeedback"
                :label="$t('Contrat')"
                :state="form.contrat.state"
                class="medium-label mb-4"
                label-for="contrat-input">
                <b-form-select
                  id="contrat-input"
                  v-model="form.contrat.value"
                  :state="form.contrat.state"
                  required
                  v-on:change="askConfirm=true;">
                  <template v-if="contrats.length === 0" #first>
                    <b-form-select-option :value="null" disabled>-- Aucun contrat actif --</b-form-select-option>
                  </template>
                  <option v-for="option in contrats" :value="option.value">
                    {{ $t(option.text) + ' - ' + option.bilanType }}
                  </option>
                </b-form-select>
              </b-form-group>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <b-form-group
                :label="$t('contrat.capital')"
                class="medium-label mb-4"
                label-for="capital-input">
                <b-form-input
                  id="capital-input"
                  v-model="capital"
                  v-disable-scroll
                  disabled
                  type="number">
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                :label="$t('contrat.rendement')"
                class="medium-label mb-4"
                label-for="rendement-input">
                <b-form-input
                  id="rendement-input"
                  v-model="rendement"
                  v-disable-scroll
                  disabled
                  type="number">
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                :label="$t('contrat.interests.estimation')"
                class="medium-label mb-4"
                label-for="interests-input">
                <b-form-input
                  id="interests-input"
                  v-model="estimationInterests"
                  v-disable-scroll
                  disabled
                  type="number">
                </b-form-input>
              </b-form-group>
            </div>
          </div>

          <div v-for="(interest, index) in form.interests" :key="index" class="row">
            <div class="col-md-6">
              <b-form-group
                :invalid-feedback="interest.amount.invalidFeedback"
                :label="$t('interest.Amount')"
                :label-for="`interest-input-'${index}`"
                :state="interest.amount.state"
                class="medium-label mb-4">
                <b-form-input
                  :id="`interest-input-'${index}`"
                  v-model="interest.amount.value"
                  v-disable-scroll
                  :state="interest.amount.state"
                  required
                  step="any"
                  type="number"
                  v-on:change="askConfirm=true;">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group
                :invalid-feedback="interest.dateInterest.invalidFeedback"
                :label="$t('interest.dateInterest')"
                :label-for="`date-interest-input-'${index}`"
                :state="interest.dateInterest.state"
                class="medium-label mb-4">
                <datepicker-input
                  :id="`date-interest-input-'${index}`"
                  v-model="interest.dateInterest.value"
                  :max="dateDeadline?dateDeadline:null"
                  :min="datePayment"
                  required
                  v-on:change="askConfirm=true;"/>
              </b-form-group>
            </div>
          </div>

          <div v-if="investorInterestId !== null" class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
          </div>

          <div v-else class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Create') }}</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>

  </div>
</template>

<script>

import backArrow from "../../../components/b122/BackArrow";
import api from "../../../services/api";
import DatepickerInput from "../../../components/b122/editFields/DatepickerInput.vue";

export default {
  name: "InvestorInterestCreateEdit",

  components: {
    backArrow,
    DatepickerInput
  },

  data() {
    return {
      investorInterestId: this.$route.params.investorInterestId,
      investorContratId: this.$route.params.investorContratId,
      investorName: this.$route.params.investorName,
      contrats: [],
      askConfirm: false,
      form: {
        contrat:
          {
            state: null,
            invalidFeedback: null,
            value: this.$route.params.investorContratId
          },
        interests: []
      },
      capital: 0,
      rendement: 0,
      datePayment: null,
      dateDeadline: null,
      estimationInterests: 0
    }
  },

  async mounted() {
    await this.fetchData()
  },

  watch: {
    'form.contrat.value': function () {
      this.fetchContrat()
    },
  },

  methods: {
    async fetchData() {
      if (this.investorInterestId) {
        await this.fetchInterest()
      } else {
        this.addInterest()
      }
      await this.fetchAllContrat()

      if (this.form.contrat.value) {
        await this.fetchContrat()
      }
    },

    async fetchInterest() {
      await api
        .get(`/investorInterest/${this.investorInterestId}`)
        .then(response => {
          this.form.contrat.value = response.data.contrat.id
          this.form.interests.push({
            amount:
              {
                state: null,
                invalidFeedback: null,
                value: Number(response.data.amount / 100)
              },
            dateInterest:
              {
                state: null,
                invalidFeedback: null,
                value: (new Date(response.data.dateInterest).toLocaleDateString().split("/").reverse().join("-"))
              }
          })
        })
    },

    async fetchAllContrat() {
      await api
        .get('/investorContrat/getAllContrat')
        .then(response => {
          this.contrats = response.data
        })
    },

    async fetchContrat() {
      await api
        .get(`/investorContrat/${this.form.contrat.value}`)
        .then(response => {
          this.datePayment = this.timestampToDateString(response.data.datePayment)
          let minTimestamp;
          if (response.data.deadline === null) {
            minTimestamp = response.data.initialDeadline;
          } else if (response.data.initialDeadline === null) {
            minTimestamp = response.data.deadline;
          } else {
            minTimestamp = Math.min(response.data.deadline, response.data.initialDeadline);
          }

          this.dateDeadline = this.timestampToDateString(minTimestamp);

          this.rendement = Number(response.data.rendement)
          this.capital = Number(response.data.initialPayment / 100).toFixed(2)
          this.estimationInterests = Number(response.data.interests / 100).toFixed(2)
        })
    },
    timestampToDateString(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    addInterest() {
      this.form.interests.push({
        amount:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        dateInterest:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      })
    },

    async onSubmit() {
      await this.createOrUpdateInvestorInterest()
    },

    async createOrUpdateInvestorInterest() {
      for (const interest of this.form.interests) {
        let data = new FormData()
        data.append('contrat', this.form.contrat.value)
        data.append('amount', interest.amount.value)
        data.append('dateInterest', interest.dateInterest.value)

        let url = 'investorInterest'
        if (this.investorInterestId) {
          url = '/investorInterest/' + this.investorInterestId
        }

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then((response) => {
            this.investorContratId = response.data.contrat.id
            this.$router.push({
              name: 'InvestorShow',
              params: {
                investorContratId: this.investorContratId ? this.investorContratId : this.form.contrat.id
              }
            })
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'InvestorInterestIndex',
                params: {
                  message: error.response.data.message
                }
              })
            } else if (error.response.status === 403) {
              const invalidField = error.response.data.invalidField
              interest[invalidField]['state'] = false
              interest[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
            }
          })
      }
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('Interest') + ' ' + this.$i18n.t('registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/investor/investorInterest/InvestorInterestCreateEdit.vue